import { IAnyEntry } from '@move-frontend/contentful';

/**
 * To allow entries to be used twice we add the index to the key to avoid undesired issues with duplicate keys.
 */
export function getListedEntryKey(entry: IAnyEntry, index: number) {
	return `${entry.id}-${index}`;
}
